import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {ExportNoteComponent} from '../../shared/ui/export-note/export-note.component';
import {StepCardDirective} from '../step-card/step-card.directive';
import {stepLabels} from '../step-card/step-labels.model';

@Component({
    selector: 'app-reading-scope-info-step',
    standalone: true,
    providers: [
        stepLabels(
            'customizedexports_export_step_reading_scope_info_title',
            'customizedexports_export_step_reading_scope_info_hint',
        ),
    ],
    hostDirectives: [{directive: StepCardDirective, inputs: ['titleKey', 'hintKey']}],
    imports: [TranslatePipe, ExportNoteComponent],
    template: `
        <app-export-note icon="bi-info-circle-fill">
            <p class="mb-2">
                {{
                    'customizedexports_export_reading_shape_info_default'
                        | translate: 'online' : 'export'
                }}
            </p>
            <p class="mb-0">
                {{
                    'customizedexports_export_reading_shape_info_channels'
                        | translate: 'online' : 'export'
                }}
            </p>
        </app-export-note>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadingScopeInfoStepComponent {}
